import { TournamentType } from '@/src/domain/models';
import { Ionicons } from '@expo/vector-icons';
import React from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { createStyles } from './CreateTournamentScreen.styles';

interface TournamentTypeCardProps {
  type: TournamentType;
  selectedType: TournamentType;
  onPress: () => void;
  title: string;
  description: string;
  icon: React.ReactNode;
  locked: boolean;
  colors: {
    card: string;
    border: string;
    text: string;
    textSecondary: string;
    primary: string;
    primaryText: string;
  };
  styles: ReturnType<typeof createStyles>;
}

export const TournamentTypeCard = ({
  type,
  selectedType,
  onPress,
  title,
  description,
  icon,
  locked,
  colors,
  styles,
}: TournamentTypeCardProps) => {
  const isSelected = selectedType === type;
  return (
    <TouchableOpacity
      disabled={locked}
      style={[
        styles.card,
        {
          backgroundColor: colors.card,
          borderColor: isSelected ? colors.primary : colors.border,
          opacity: locked ? 0.6 : 1,
        },
      ]}
      onPress={onPress}
    >
      <View style={styles.cardHeader}>
        {icon}
        <Text style={[styles.cardTitle, { color: colors.text }]}>{title}</Text>
        {locked && (
          <View style={{ marginLeft: 'auto', flexDirection: 'row', alignItems: 'center', backgroundColor: '#FFD700', paddingHorizontal: 6, paddingVertical: 2, borderRadius: 8 }}>
            <Ionicons name="lock-closed" size={10} color="#8B4513" />
            <Text style={{ fontSize: 10, fontWeight: 'bold', color: '#8B4513', marginLeft: 2 }}>PRO</Text>
          </View>
        )}
      </View>
      <Text style={[styles.cardDesc, { color: colors.textSecondary }]}>{description}</Text>
      {isSelected && (
        <View style={[styles.checkBadge, { backgroundColor: colors.primary }]}>
          <Ionicons name="checkmark" size={16} color={colors.primaryText} />
        </View>
      )}
    </TouchableOpacity>
  );
};
